import { Button, ButtonProps } from '@mui/material';

export const PrimaryButton = ({ sx, ...rest }: ButtonProps) => (
  <Button
    {...rest}
    sx={{
      borderRadius: '8px',
      border: '1px solid rgba(255, 255, 255, 0.06)',
      backgroundColor: '#2A2A32',
      minWidth: 'min-content',
      [':hover']: {
        border: '1px solid rgba(255, 255, 255, 0.12)',
        backgroundColor: '#36363f',
      },
      ...sx,
    }}
  />
);
